import * as Sentry from "@sentry/browser";

declare global {
  var SENTRY_DSN: string;
}

Sentry.init({
  dsn: globalThis.SENTRY_DSN,
});
